import { AxiosResponse } from 'axios';
import { USERS_API_URL } from '../../../../config';
import { PaginatedSuppliers } from '../../../../interfaces/suppliers/paginatedStore.type';
import brokersAxios from '../../../../utils/axios/brokers-roles.axios';

const tryToFetchSuppliers = (
    pageNumber: number,
    pageSize: number,
    data?: any,
): Promise<AxiosResponse<PaginatedSuppliers>> => {
    const url = `${USERS_API_URL}/suppliers/all?page=${pageNumber}&size=${pageSize}`;
    return brokersAxios.put<PaginatedSuppliers>(url, { filters: data })
}

const tryToCreateSuppliers = (data: any): Promise<AxiosResponse> => {
    return brokersAxios.post(`${USERS_API_URL}/suppliers`, data);
};

const tryToEditSuppliers = (id: string, data: any): Promise<AxiosResponse> => {
    return brokersAxios.put(`${USERS_API_URL}/suppliers/${id}/edit`, data);
};

const tryToFetchSingleSuppliers = (id: string): Promise<AxiosResponse> => {
    return brokersAxios.get(`${USERS_API_URL}/suppliers/${id}`)
};

const tryToFetchAllSuppliers = (): Promise<AxiosResponse> => {
    return brokersAxios.get(`${USERS_API_URL}/suppliers/all`)
};

const tryToEnableDisableSuppliers = (id: string, status: boolean): Promise<AxiosResponse> => {
    return brokersAxios.put(`${USERS_API_URL}/suppliers/${id}/${status}`);
};

const tryToDeleteSuppliers = (id: string): Promise<AxiosResponse> => {
    return brokersAxios.delete(`${USERS_API_URL}/suppliers/${id}`);
};

const tryToFetchAllPartners = (): Promise<AxiosResponse<any[]>> => {
    return brokersAxios.put(`${USERS_API_URL}/partners?flag=true`);
};

export const SuppliersService = {
    tryToFetchSuppliers,
    tryToFetchAllSuppliers,
    tryToCreateSuppliers,
    tryToEditSuppliers,
    tryToFetchSingleSuppliers,
    tryToEnableDisableSuppliers,
    tryToDeleteSuppliers,
    tryToFetchAllPartners
}